import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/loading.gif';
import _imports_1 from '@/assets/images/coin.png';
import _imports_2 from '@/assets/images/yulan.png';
import _imports_3 from '../../assets/images/mine/video_detail_send.png';
import _imports_4 from '../../assets/images/mine/video_detail_like.png';

const _withScopeId = n => (_pushScopeId("data-v-3bbfef52"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "videoDetails"
};
const _hoisted_2 = {
  class: "head_title head_top_20"
};
const _hoisted_3 = {
  class: "video_box"
};
const _hoisted_4 = {
  class: "loading"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = {
  key: 1,
  class: "loading"
};
const _hoisted_8 = ["id"];
const _hoisted_9 = ["poster"];
const _hoisted_10 = {
  class: "cont webkit-overflow-scrolling-touch"
};
const _hoisted_11 = {
  class: "tab_cont"
};
const _hoisted_12 = {
  class: "user_top"
};
const _hoisted_13 = {
  class: "img_box"
};
const _hoisted_14 = {
  class: "text_box"
};
const _hoisted_15 = {
  class: "text_ellipsis"
};
const _hoisted_16 = {
  class: "text_ellipsis"
};
const _hoisted_17 = {
  class: "btn_box"
};
const _hoisted_18 = {
  class: "info-title"
};
const _hoisted_19 = {
  key: 0,
  class: "info-tagList"
};
const _hoisted_20 = {
  class: "coin tag_item"
};

const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));

const _hoisted_22 = ["onClick"];

const _hoisted_23 = /*#__PURE__*/_createTextVNode("无法播放? ");

const _hoisted_24 = {
  class: "info-time"
};

const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "dian"
}, "·", -1));

const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "dian"
}, "·", -1));

const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info-btn-box"
}, null, -1));

const _hoisted_28 = {
  class: "advertse"
};
const _hoisted_29 = {
  class: "info-recommend"
};

const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "info-recommend-title"
}, "为你推荐", -1));

const _hoisted_31 = ["onClick"];
const _hoisted_32 = {
  class: "info-videoCover"
};
const _hoisted_33 = {
  class: "info-videoCover-img"
};
const _hoisted_34 = ["onClick"];

const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1));

const _hoisted_36 = [_hoisted_35];
const _hoisted_37 = {
  class: "info-videoInfo"
};
const _hoisted_38 = {
  key: 0,
  class: "bottom"
};

const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1));

const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "优质评论优先展示", -1));

const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1));

const _hoisted_42 = [_hoisted_39, _hoisted_40, _hoisted_41];
const _hoisted_43 = {
  class: "video-detail-input"
};
const _hoisted_44 = {
  class: "input-box"
};

const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3
}, null, -1));

const _hoisted_46 = {
  class: "details_page"
};
const _hoisted_47 = {
  class: "details_page"
};
const _hoisted_48 = {
  class: "dialog_content"
};

const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "无法播放原因", -1));

const _hoisted_50 = {
  class: "details_page_app"
};
const _hoisted_51 = {
  class: "head_title"
};

const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "详情", -1));

const _hoisted_53 = {
  class: "cont_body_app"
};
const _hoisted_54 = {
  class: "dialog_content"
};

const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "填写手机号", -1));

const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, " 为了防止账号丢失，且便于推荐新片，请设置您的手机号，绑定手机可每日免费看5部电影！~ ", -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  const _component_van_notice_bar = _resolveComponent("van-notice-bar");

  const _component_my_image = _resolveComponent("my-image");

  const _component_advertise_swipe = _resolveComponent("advertise-swipe");

  const _component_search_popup = _resolveComponent("search-popup");

  const _component_van_popup = _resolveComponent("van-popup");

  const _component_ask_video = _resolveComponent("ask-video");

  const _component_van_radio = _resolveComponent("van-radio");

  const _component_van_cell = _resolveComponent("van-cell");

  const _component_van_cell_group = _resolveComponent("van-cell-group");

  const _component_van_radio_group = _resolveComponent("van-radio-group");

  const _component_ask_for_video_details = _resolveComponent("ask-for-video-details");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_icon, {
    size: "22",
    name: "arrow-left",
    onClick: $setup.close
  }, null, 8, ["onClick"])]), _createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("div", _hoisted_4, _hoisted_6, 512), [[_vShow, $setup.showLoading && (!$setup.showStart || !$setup.videoImgs.start)]]), $setup.videoImgs.run?.remark ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "notic",
    onClick: _cache[0] || (_cache[0] = $event => $setup.toBannerDetails($setup.videoImgs.run))
  }, [_createVNode(_component_van_notice_bar, {
    background: "#0000",
    color: "#ffffff",
    scrollable: "",
    text: $setup.videoImgs.run.remark
  }, null, 8, ["text"])])) : _createCommentVNode("", true), $setup.showStart && $setup.videoImgs.start?.url || $setup.showEnd && $setup.videoImgs.end?.url || $setup.showStop && $setup.videoImgs.stop?.url ? (_openBlock(), _createElementBlock("div", _hoisted_7, [$setup.videoImgs.start && $setup.showStart ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "a",
    onClick: _cache[2] || (_cache[2] = $event => $setup.toBannerDetails($setup.videoImgs.start))
  }, [(_openBlock(), _createBlock(_component_my_image, {
    url: $setup.videoImgs.start.url,
    key: $setup.videoImgs.start.url
  }, null, 8, ["url"])), $setup.showLoading ? (_openBlock(), _createBlock(_component_van_icon, {
    key: 0,
    onClick: _cache[1] || (_cache[1] = _withModifiers($event => $setup.showStart = false, ["stop"])),
    name: "close"
  })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $setup.videoImgs.end && $setup.showEnd ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "b",
    onClick: _cache[4] || (_cache[4] = $event => $setup.toBannerDetails($setup.videoImgs.end))
  }, [(_openBlock(), _createBlock(_component_my_image, {
    url: $setup.videoImgs.end.url,
    key: $setup.videoImgs.end.url
  }, null, 8, ["url"])), _createVNode(_component_van_icon, {
    onClick: _cache[3] || (_cache[3] = _withModifiers($event => $setup.showEnd = false, ["stop"])),
    name: "close"
  })])) : _createCommentVNode("", true), $setup.videoImgs.stop && $setup.showStop ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "b",
    onClick: _cache[6] || (_cache[6] = $event => $setup.toBannerDetails($setup.videoImgs.stop))
  }, [(_openBlock(), _createBlock(_component_my_image, {
    url: $setup.videoImgs.stop.url,
    key: $setup.videoImgs.stop.url
  }, null, 8, ["url"])), _createVNode(_component_van_icon, {
    onClick: _cache[5] || (_cache[5] = _withModifiers($event => $setup.showStop = false, ["stop"])),
    name: "close"
  })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", {
    id: $setup.videoBoxId,
    class: "videoBox"
  }, [_createElementVNode("video", {
    poster: $setup.options.poster,
    id: "videoPlayer",
    class: "video-js videoPlayer"
  }, null, 8, _hoisted_9)], 8, _hoisted_8), [[_vShow, !$setup.showLoading]])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [(_openBlock(), _createBlock(_component_my_image, {
    key: $setup.detailsData.id,
    url: $setup.detailsData.top_image || '/123.png'
  }, null, 8, ["url"]))]), _createElementVNode("div", _hoisted_14, [_createElementVNode("p", _hoisted_15, _toDisplayString($setup.detailsData.nickname), 1), _createElementVNode("p", _hoisted_16, _toDisplayString($setup.detailsData.user_label) + "- " + _toDisplayString($setup.detailsData.fans || 0) + "粉丝 ·" + _toDisplayString($setup.detailsData.video_num) + "视频 ", 1)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("p", {
    onClick: _cache[7] || (_cache[7] = (...args) => $setup.focusSave && $setup.focusSave(...args)),
    style: _normalizeStyle({
      background: $setup.detailsData.isFocus ? '#5B5B5B' : '#276AD3'
    })
  }, _toDisplayString($setup.detailsData.isFocus ? "已关注" : "关注"), 5)])]), _createElementVNode("p", _hoisted_18, _toDisplayString($setup.detailsData.title), 1), $setup.detailsData.label ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("span", _hoisted_20, [_hoisted_21, _createTextVNode(" " + _toDisplayString($setup.detailsData.money), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.detailsData.label, item => {
    return _openBlock(), _createElementBlock("span", {
      onClick: $event => $setup.labelSearch(item),
      key: item,
      class: "tag_item"
    }, "#" + _toDisplayString(item), 9, _hoisted_22);
  }), 128))])) : _createCommentVNode("", true), _createElementVNode("p", {
    class: "no-play",
    onClick: _cache[8] || (_cache[8] = (...args) => $setup.noPlay && $setup.noPlay(...args))
  }, [_createVNode(_component_van_icon, {
    name: "warning-o"
  }), _hoisted_23]), _createElementVNode("p", _hoisted_24, [_createTextVNode(_toDisplayString($setup.detailsData.count) + "次播放", 1), _hoisted_25, _createTextVNode(_toDisplayString($setup.detailsData.like_num) + "赞", 1), _hoisted_26, _createTextVNode(_toDisplayString($setup.detailsData.day || "") + "发布 ", 1)]), _hoisted_27, _createElementVNode("div", _hoisted_28, [_createVNode(_component_advertise_swipe, {
    type: 2
  })]), _createElementVNode("div", _hoisted_29, [_hoisted_30, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tjList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: item.id,
      class: "info-videoItem",
      onClick: $event => $setup.videoPlay(item)
    }, [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", null, [_createVNode(_component_my_image, {
      url: item.image
    }, null, 8, ["url"])])]), _createElementVNode("div", {
      class: "yulan",
      onClick: _withModifiers($event => $setup.videoPlay(item, 'yl'), ["stop"])
    }, _hoisted_36, 8, _hoisted_34), _createElementVNode("span", null, _toDisplayString(item.times), 1)]), _createElementVNode("div", _hoisted_37, [_createElementVNode("p", null, _toDisplayString(item.title), 1), _createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString(item.context), 1), _createElementVNode("span", null, _toDisplayString(item.count) + "次播放", 1)])])], 8, _hoisted_31);
  }), 128))])])]), false ? (_openBlock(), _createElementBlock("div", _hoisted_38, [_createElementVNode("div", {
    class: "input_box",
    onClick: _cache[9] || (_cache[9] = (...args) => $setup.inputSend && $setup.inputSend(...args))
  }, _hoisted_42)])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_hoisted_45, _withDirectives(_createElementVNode("input", {
    id: "inputId",
    type: "text",
    "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $setup.message = $event),
    placeholder: "优质评论优先展示"
  }, null, 512), [[_vModelText, $setup.message]])]), _createElementVNode("span", {
    class: "input-sub",
    onClick: _cache[11] || (_cache[11] = (...args) => $setup.send && $setup.send(...args))
  }, "确定")], 512), [[_vShow, $setup.showInput]]), _createVNode(_component_van_popup, {
    show: $setup.showSearchPopup,
    "onUpdate:show": _cache[12] || (_cache[12] = $event => $setup.showSearchPopup = $event),
    class: "popup_coentent",
    overlay: false,
    position: "right"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_46, [(_openBlock(), _createBlock(_component_search_popup, {
      searchText: $setup.searchText,
      key: $setup.key,
      type: 'details',
      label_name: $setup.label_name,
      onClose: $setup.close1
    }, null, 8, ["searchText", "label_name", "onClose"]))])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.showAskVideo,
    "onUpdate:show": _cache[13] || (_cache[13] = $event => $setup.showAskVideo = $event),
    class: "popup_coentent",
    overlay: false,
    position: "right"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_47, [(_openBlock(), _createBlock(_component_ask_video, {
      detailsData: $setup.detailsData,
      key: $setup.detailsData.id,
      onClose: $setup.close2
    }, null, 8, ["detailsData", "onClose"]))])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.showDialog,
    "onUpdate:show": _cache[17] || (_cache[17] = $event => $setup.showDialog = $event),
    round: ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_48, [_hoisted_49, _createVNode(_component_van_radio_group, {
      modelValue: $setup.checked,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $setup.checked = $event),
      "checked-color": "#FF551D"
    }, {
      default: _withCtx(() => [_createVNode(_component_van_cell_group, {
        inset: ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, item => {
          return _openBlock(), _createBlock(_component_van_cell, {
            clickable: "",
            key: item,
            title: item.label,
            onClick: $event => $setup.toggle(item)
          }, {
            "right-icon": _withCtx(() => [_createVNode(_component_van_radio, {
              name: item.value
            }, null, 8, ["name"])]),
            _: 2
          }, 1032, ["title", "onClick"]);
        }), 128))]),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue"]), $setup.checked === 3 ? _withDirectives((_openBlock(), _createElementBlock("input", {
      key: 0,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $setup.fkMessage = $event),
      type: "text",
      "max-length": "8",
      placeholder: "请输入反馈内容"
    }, null, 512)), [[_vModelText, $setup.fkMessage]]) : _createCommentVNode("", true), _createElementVNode("div", {
      class: "btns",
      onClick: _cache[16] || (_cache[16] = (...args) => $setup.noPlayOk && $setup.noPlayOk(...args))
    }, "确认")])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.showAskVideoDetails,
    "onUpdate:show": _cache[18] || (_cache[18] = $event => $setup.showAskVideoDetails = $event),
    class: "popup_coentent",
    overlay: false,
    teleport: "#app",
    position: "right"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_createVNode(_component_van_icon, {
      size: "22",
      name: "arrow-left",
      onClick: _withModifiers($setup.close3, ["stop"])
    }, null, 8, ["onClick"]), _hoisted_52]), _createElementVNode("div", _hoisted_53, [(_openBlock(), _createBlock(_component_ask_for_video_details, {
      key: $setup.ask_video_id,
      id: $setup.ask_video_id
    }, null, 8, ["id"]))])])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.showDialog3,
    "onUpdate:show": _cache[21] || (_cache[21] = $event => $setup.showDialog3 = $event),
    round: ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_54, [_hoisted_55, _hoisted_56, _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => $setup.phone = $event),
      type: "text",
      "max-length": "11",
      placeholder: "请输入手机号号"
    }, null, 512), [[_vModelText, $setup.phone]]), _createElementVNode("div", {
      class: "btns",
      onClick: _cache[20] || (_cache[20] = (...args) => $setup.okBtns3 && $setup.okBtns3(...args))
    }, "确认")])]),
    _: 1
  }, 8, ["show"])]);
}